import {DataObjectId} from './data-object'
import {Schedule, toServerSchedule} from './schedule'

export interface RepeatTemplate {
  schedule?: Schedule
  savedSchedule?: Schedule
  id: DataObjectId
  columnId: DataObjectId
  title: string
  titleSuffix?: 'date' | 'order'
  allTasks?: DataObjectId[]
  latestRepeatTime?: number
}

export type RepeatTemplateEssential = Omit<
  RepeatTemplate,
  'allTasks' | 'latestRepeatTime'
>

export const extractRepeatTemplateEssential = (
  tpl: RepeatTemplate | undefined
): RepeatTemplateEssential | undefined => {
  if (!tpl) {
    return undefined
  }
  const {allTasks: _, latestRepeatTime: __, ...essential} = tpl
  return essential
}

export const createDefaultRepeatTemplate = ({
  columnId,
  title,
  id
}: {
  id: DataObjectId
  columnId: DataObjectId
  title: string
}): RepeatTemplate => ({
  title,
  schedule: toServerSchedule({
    type: 'daily',
    minute: 0,
    hour: 12
  }),
  id,
  columnId,
  allTasks: [],
  titleSuffix: 'order'
})
